module.exports = __webpack_public_path__ + "static/media/bs.6fe877e1.svg";